export default __webpack_public_path__ + "media/rebeccaEVid.8a19039d.mp4";